import React, { useEffect, useMemo, useState } from 'react';
import { PrivyWagmiConnector } from "@privy-io/wagmi-connector";
import { usePrivy, useWallets } from '@privy-io/react-auth';
import { ZeroDevPrivyConnector } from './ZeroDevPrivyConnector';
const KERNEL_API_URL = 'https://kernel-api.zerodev.app';
export const ZeroDevPrivyWagmiProvider = ({ options, wagmiChainsConfig, children }) => {
    const { ready, authenticated, user, logout } = usePrivy();
    const { wallets: eoaWallets } = useWallets();
    const [data, setData] = useState();
    const [connectorKey, setConnectorKey] = useState(0);
    const { chains } = wagmiChainsConfig;
    const hasEmbeddedWallet = !!(user && user.linkedAccounts.find((account) => account.type === 'wallet' && account.walletClientType === 'privy'));
    const embeddedWallet = eoaWallets.find((wallet) => (wallet.walletClientType === 'privy'));
    const { useRecoveredAccount, useSmartWalletForExternalEOA } = options;
    const readyForConnector = ready && authenticated;
    const activeWallet = useMemo(() => {
        if (hasEmbeddedWallet) {
            return embeddedWallet;
        }
        else {
            return eoaWallets[0];
        }
    }, [hasEmbeddedWallet, embeddedWallet?.address, eoaWallets?.[0]?.address]);
    useEffect(() => {
        const getAddress = async () => {
            if (useRecoveredAccount && activeWallet?.address) {
                const url = `${KERNEL_API_URL}/accounts/by-owner?ownerAddress=${activeWallet.address}`;
                try {
                    const response = await fetch(url);
                    const data = (await response.json());
                    if (data.length) {
                        setData(data);
                        return;
                    }
                    setData(undefined);
                }
                catch (error) {
                    setData(undefined);
                }
            }
        };
        getAddress();
    }, [useRecoveredAccount, activeWallet?.address]);
    const connector = useMemo(() => {
        if (!readyForConnector)
            return;
        if (useSmartWalletForExternalEOA === false && !hasEmbeddedWallet) {
            return undefined;
        }
        else {
            const kernelData = data?.[data.length - 1];
            setConnectorKey(connectorKey + 1);
            return new ZeroDevPrivyConnector({ logout, chains, activeWallet, options, kernelAddress: kernelData?.kernel });
        }
    }, [readyForConnector, chains, useSmartWalletForExternalEOA, activeWallet?.address, eoaWallets?.[0]?.address]);
    return (React.createElement(PrivyWagmiConnector, { key: connectorKey, wagmiChainsConfig: wagmiChainsConfig, privyConnectorOverride: connector }, children));
};
